import { Study } from "../../../../shared/entities/scripts/study";
import { DoArraysOverlap } from "../../../../shared/scripts/array-functions";
import { GetDateFromString } from "../../../../shared/scripts/date-functions";
import { PadNumber } from "../../../../shared/scripts/number-functions";
import { FormatStringColumnByLength } from "../../../../shared/scripts/table-functions";
import { SiteMilestone } from "../../sites/site-activation/scripts/site-activation.entities";
import { ContractsLookup } from "./contracts.lookup";

export class Contract {

    ContractNumber: string;
    ContractName: string;
    DateLastStatusStart: string;
    DateExecuted: string;
    DateContractStart: string;
    DateContractEnd: string;
    DateContractAdded: string;
    DaysToExecution: string;
    SiteCode: string;
    PrimeContractId: number;
    ContractTypeId: number;
    StatusId: number;
    StatusGroupId: number;
    SiteNumber: number;
    //SiteIdStr: string;
    IsVanguardSite: number;

    PrimeContract: string;
    ContractType: string;
    Status: string;
    StatusGroup: string;

    ContractNameDisplay: string;
    AddedDate: Date;
    LastChangeDate: Date;

    StatusDisplay: string;
    MilestoneDisplay: string;
    VanguardSiteDisplay: string;
    SiteNumberDisplay: string;

    History: ContractHistory[];
    //HistoryDateMap: Map<string, number>;
    HistoryUniqueDates: number[]; //unique dates that events happened

    Milestones: SiteMilestone[];
    MilestoneDateMap: Map<string, number>;
    //MilestoneMap: Map<string, SiteMilestone>;
    //MilestoneUniqueDates: number[];

    //IsRecoverCohortSite: boolean = undefined;

    static count: number = 0;

    initialize(): void {

        //this.PrimeContract = ContractsLookup.GetPrimeContract(this.PrimeContractId);
        this.PrimeContract = Study.GetStudyName(this.PrimeContractId)
        this.ContractType = ContractsLookup.GetContractType(this.ContractTypeId);
        this.Status = ContractsLookup.GetContractStatus(this.StatusId);
        this.StatusGroup = ContractsLookup.GetContractStatusGroup(this.StatusGroupId);

        this.ContractNameDisplay = FormatStringColumnByLength(this.ContractName, 4);

        this.AddedDate = GetDateFromString(this.DateContractAdded, "slash-month-day-year");
        this.LastChangeDate = GetDateFromString(this.DateLastStatusStart, "slash-month-day-year");

        this.StatusDisplay = "<a onclick='page.showContractDetails(\"" + this.ContractNumber + "\", \"history\")'><span class='nowrap'>" + this.Status + "</span></a>";

        if (this.IsVanguardSite == 1) this.VanguardSiteDisplay = "Yes";
        else if (this.IsVanguardSite == 2) this.VanguardSiteDisplay = "No";
        else this.VanguardSiteDisplay = "Not Applicable";

        if (this.SiteNumber > 0) this.SiteNumberDisplay = PadNumber(this.SiteNumber + "", 3);
        else this.SiteNumberDisplay = "";

        delete this.PrimeContractId;
        delete this.ContractTypeId;
        delete this.StatusId;
        delete this.StatusGroupId;
        delete this.IsVanguardSite;

        //console.log(this);
    }

    setContractHistory(history: ContractHistory[]): void {
        this.History = history.sort((a: ContractHistory, b: ContractHistory) => a.StartDateTimestamp-b.StartDateTimestamp);
        //this.HistoryDateMap = new Map<string, number>();
        this.HistoryUniqueDates = [];
        let historyTimes: number[] = [];

        this.History.forEach((history: ContractHistory) => {
            //if (!this.HistoryDateMap.has(history.StatusGroup)) { //only want first occurence
                //this.HistoryDateMap.set(history.StatusGroup, history.StartDate.getTime());
            //}
            if (!historyTimes.includes(history.StartDate.getTime())) {
                this.HistoryUniqueDates.push(history.StartDate.getTime());
                historyTimes.push(history.StartDate.getTime());
            }
        });

        //console.log(this.HistoryDates);
        //console.log(this.HistoryDateMap);
    }

    setSiteMilestones(milestones: SiteMilestone[]): void {
        this.MilestoneDisplay = ""; //this.SiteIdStr = "";

        if (milestones.length > 0) {
            this.Milestones = milestones;
            //this.IsRecoverCohortSite = false;
            //this.SiteIdStr = milestones[0].SiteIdStr;
            this.SiteNumber = milestones[0].SiteNumber;

            let selectedMilestone: string = "Milestone";
            let selectedTimestamp: number = 0;
            for (let i = milestones.length; i >= 0; --i) {
                if (milestones[i]?.CompletionDate?.getTime() > selectedTimestamp) {
                    selectedMilestone = milestones[i].Milestone;
                    selectedTimestamp = milestones[i].CompletionDate.getTime();
                }
            }
            this.MilestoneDisplay = "<a onclick='page.showContractDetails(\"" + this.ContractNumber + "\", \"milestone\")'><span class='nowrap'>" + selectedMilestone + "</span></a>";
        }
    }

    matchesFilter(primeContract: any, contractType: any, statusGroup: any, changedSinceDate: any, addedSinceDate: any): boolean {

        //console.log(primeContract, contractType, statusGroup, changedSinceDate, addedSinceDate);
        //console.log(changedSinceDate, addedSinceDate);

        if (primeContract != undefined && !DoArraysOverlap(primeContract, this.PrimeContract)) { return false; }
        if (contractType != undefined && !DoArraysOverlap(contractType, this.ContractType)) { return false; }
        if (statusGroup != undefined && !DoArraysOverlap(statusGroup, this.StatusGroup)) { return false; }
        //if (vanguardSite != undefined && vanguardSite.indexOf(this.VanguardSiteDisplay) === -1) { return false; }
        if (changedSinceDate != undefined && changedSinceDate != null) {
            if (this.LastChangeDate == undefined) { return false; }
            else if (this.LastChangeDate < changedSinceDate) return false;
        }
        if (addedSinceDate != undefined && addedSinceDate != null) {
            if (this.AddedDate == undefined) { return false; }
            else if (this.AddedDate < addedSinceDate) return false;
        }

        return true;
    }

    //isContractInStatusGroupOnDate(statusGroup: string, checkDate: number): boolean {

    //    if (this.HistoryDateMap.has(statusGroup)) {
    //        let contractDate: number = this.HistoryDateMap.get(statusGroup);
    //        if (contractDate <= checkDate) { return true; }
    //    }
    //    return false;        
    //}

    getContractStatusOnDate(checkDate: number): string {
        let statusesOnDate: string[] = [];
        let latestMatchingDate: number = -1;
        let currentDate: number;

        for (let i: number = 0; i < this.History.length; ++i) {
            currentDate = this.History[i].StartDateTimestamp;
            if (checkDate >= currentDate) {
                if (latestMatchingDate != currentDate) {
                    latestMatchingDate = currentDate;
                    statusesOnDate = [];
                }
                statusesOnDate.push(this.History[i].StatusGroup);
            }
            if (checkDate < currentDate) { break; }
        }

        //need to check hierarchy to account for contract updates on same day
        let statusHierarchy: string[] = ["Fully Executed", "Signature", "Negotiation"];
        for (let i: number = 0; i < statusHierarchy.length; ++i) {
            if (statusesOnDate.includes(statusHierarchy[i])) { return statusHierarchy[i]; }
        }

        return "";
    }

    isMilestoneCompletedOnDate(milestone: string, checkDate: number): boolean {

        if (this.MilestoneDateMap.has(milestone)) {
            let completionDate: number = this.MilestoneDateMap.get(milestone);
            if (completionDate <= checkDate) { return true; }
        }
        return false;
    }

    //getMilestoneByMilestone(milestoneLabel: string): SiteMilestone {
    //    return this.MilestoneMap.get(milestoneLabel);
    //}
}


export class ContractHistory {

    ContractNumber: string;
    ContractName: string; 
    DateStatusStart: string; 
    DateStatusEnd: string;
    Duration: string;
    PrimeContractId: number;
    ContractTypeId: number;
    StatusId: number;
    StatusGroupId: number;

    PrimeContract: string; 
    ContractType: string; 
    Status: string;
    StatusGroup: string; 
    SortDate: Date;
    StartDate: Date;
    EndDate: Date;
    ContractNameDisplay: string;

    StartDateTimestamp: number;

    initialize(): void {

        //this.PrimeContract = ContractsLookup.GetPrimeContract(this.PrimeContractId);
        this.PrimeContract = Study.GetStudyName(this.PrimeContractId);
        this.ContractType = ContractsLookup.GetContractType(this.ContractTypeId);
        this.Status = ContractsLookup.GetContractStatus(this.StatusId);
        this.StatusGroup = ContractsLookup.GetContractStatusGroup(this.StatusGroupId);

        this.ContractNameDisplay = FormatStringColumnByLength(this.ContractName, 4);

        this.StartDate = GetDateFromString(this.DateStatusStart, "slash-month-day-year");
        this.StartDateTimestamp = this.StartDate.getTime();
        this.SortDate = this.StartDate;
        this.EndDate = GetDateFromString(this.DateStatusEnd, "slash-month-day-year");

        delete this.PrimeContractId;
        delete this.ContractTypeId;
        delete this.StatusId;
        delete this.StatusGroupId;
    }

    matchesFilter(primeContract: any, contractType: any, status: any): boolean {

        //console.log(primeContract, contractType, statusGroup, changedSinceDate, addedSinceDate);
        //console.log(changedSinceDate, addedSinceDate);

        if (!DoArraysOverlap(primeContract, this.PrimeContract)) { return false; }
        if (!DoArraysOverlap(contractType, this.ContractType)) { return false; }
        //if (!DoArraysOverlap(status, this.Status)) { return false; }
        if (!DoArraysOverlap(status, this.StatusGroup)) { return false; }

        return true;
    }
}
